import { PHONE, locationSchema } from "../structured-data-core";

export function getPhoenixStructuredData() {
  const url = "https://restorehair.com/locations/arizona/phoenix/";
  const description =
    "Find out about your hair transplant options in Phoenix with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Phoenix", "7150 E Camelback Rd", "Scottsdale", "AZ", PHONE, url, description),
  ];
}
